<template>
    <div ref="multilineChartContainer">
        <highcharts v-if="Object.keys(chartData).length" :options="chartData" ref="multilineChart" />
    </div>
</template>
<script>
export default {
    name: "MultiLineChart",
    data() {
        return {
            chartData: {},
        }
    },
    props: {
        rawData: {
            /* 
                This object contains data like so

                categories: [],
                seriesData: [
                    {
                        name: reviewSeries.product_name,
                        data: [],
                        color: colors[index]
                    }, ...
                ]
            */
            type: Object,
            required: true
        },
        height: Number,
        legendVerticalAlign: String,
        legendHorizontalAlign: String,
    },
    mounted() {
        this.plotChart();
        this.resizeObserver = new ResizeObserver(() => {
            this.resizeChart();
        });
        this.resizeObserver.observe(this.$refs.multilineChartContainer);
    },
    watch: {
        rawData: {
            handler() {
                this.plotChart();
            },
            deep: true
        }
    },
    methods: {
        resizeChart() {
            if (this.$refs.multilineChart.chart) {
                this.$refs.multilineChart.chart.reflow();
            }
        },
        plotChart() {
            this.chartData = {
                chart: {
                    height: this.height || null
                },
                title: {
                    text: ''
                },
                credits: {
                    enabled: false
                },
                exporting: {
                    enabled: false,
                },
                xAxis: {
                    categories: this.rawData.categories,
                    title: {
                        text: null
                    },
                    tickmarkPlacement: 'on',
                    // tickPositioner: function () {
                    //     if (this.dataMax <= 5) return;
                    //     let tick = Math.floor(this.dataMin);
                    //     const positions = [],
                    //         increment = Math.ceil((this.dataMax - this.dataMin) / 5);

                    //     if (this.dataMax !== null && this.dataMin !== null) {
                    //         for (tick;
                    //             tick - increment <= this.dataMax;
                    //             tick += increment) {
                    //             positions.push(tick);
                    //         }
                    //     }
                    //     positions[positions.length - 1] = this.dataMax
                    //     return positions;
                    // },
                    labels: {
                        style: {
                            fontFamily: 'Poppins',
                            fontSize: '14px',
                            fontWeight: '500',
                            lineHeight: '16px',
                            textAlign: 'center',
                            color: '#A1A1A1'
                        },
                        y: 30,
                    },
                },
                yAxis: {
                    title: {
                        text: null
                    },
                    visible: true,
                    lineWidth: 1,
                    labels: {
                        style: {
                            fontFamily: 'Poppins',
                            fontSize: '14px',
                            fontWeight: '500',
                            lineHeight: '16px',
                            textAlign: 'center',
                            color: '#A1A1A1'
                        },
                    },
                    gridLineColor: '#E4EDEE',
                    gridLineWidth: 1.5,
                    gridLineDashStyle: 'Dash'
                },
                tooltip: {
                    shared: true,
                    borderWidth: 1,
                    borderColor: "rgba(212, 212, 212, 1)",
                    shadow: {
                        color: "#d6d6d6",
                        opacity: 0.1,
                        width: 10,
                    },
                    borderRadius: 15,
                    backgroundColor: "#ffffff",
                    style: {
                        fontSize: "14px",
                        fontFamily: 'Poppins',
                        fontWeight: '500',
                    },
                    padding: 10,
                },
                series: this.rawData.seriesData,
                legend: {
                    align: this.legendHorizontalAlign || 'right',
                    verticalAlign: this.legendVerticalAlign || 'top',
                    layout: 'horizontal',
                    x: 0,
                    y: 0,
                    itemStyle: {
                        fontSize: '14px',
                        fontWeight: 500,
                        fontFamily: 'Poppins, sans-serif',
                        color: '#A1A1A1',
                        textTransform: 'capitalize'
                    }
                },
                plotOptions: {
                    series: {
                        marker: {
                            enabled: true,
                            radius: 6,
                            fillColor: 'white',
                            lineWidth: 2,
                            lineColor: null,
                            symbol: 'circle'
                        },
                    }
                }
            }
        }
    }
}
</script>